import { Card, CardContent } from "@/components/ui/card";

const Videos = () => {
  return (
    <div className="container py-8 animate-fade-in">
      <Card className="w-full max-w-3xl mx-auto overflow-hidden">
        <CardContent className="relative p-0">
          {/* Gradient background with animated overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#fdfcfb] to-[#e2d1c3] opacity-50" />
          <div className="absolute inset-0 bg-[linear-gradient(60deg,_transparent_0%,_rgba(255,255,255,0.2)_100%)] animate-pulse" />
          
          {/* Content container */}
          <div className="relative flex flex-col items-center justify-center min-h-[500px] text-center p-8">
            {/* Decorative elements */}
            <div className="absolute top-10 right-10 w-24 h-24 rounded-full bg-accent/20 blur-xl animate-pulse" />
            <div className="absolute bottom-10 left-10 w-20 h-20 rounded-full bg-primary/20 blur-lg animate-pulse" />
            <div className="absolute top-1/4 left-1/4 w-16 h-16 rounded-full bg-secondary/30 blur-md" />
            
            {/* Main content with staggered animation */}
            <div className="relative space-y-12 max-w-lg">
              {/* Title section */}
              <div className="relative">
                <h1 className="text-3xl text-primary font-montserrat relative inline-block">
                  Videos
                </h1>
              </div>
              
              {/* Description with simplified layout */}
              <div className="relative">
                <p className="text-xl text-foreground/80 font-raleway leading-relaxed">
                  A reimagined OS for crafting Videos on LinkedIn
                </p>
              </div>
              
              {/* Enhanced Coming Soon badge with fancy gradient */}
              <div className="relative inline-block group">
                <div className="absolute inset-0 bg-gradient-to-r from-accent via-primary/30 to-accent/50 opacity-75 blur-lg group-hover:blur-xl transition-all" />
                <p className="relative text-2xl text-primary font-raleway px-8 py-3 border border-accent/20 rounded-full backdrop-blur-sm bg-white/10 shadow-lg transform transition-all duration-300 group-hover:scale-105 group-hover:shadow-xl">
                  Coming Soon
                  <span className="absolute inset-0 bg-gradient-to-r from-accent/10 via-primary/5 to-accent/10 rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Videos;